import React from "react"

import Table from "../../../../components/Table/Table"
import EditLocationDetails from "../EditSites"
import CommonAgGrid from "../../../../components/AgGridTable"

const SitesTable = ({ states, functions }: any) => {
    return (
        <>
            {/* <Table
                headerData={states.headerData}
                rowData={states.rowData}
                loading={states.isSitesLoading}
                height={"85%"}
                pagination={{
                    TotalPage: states.totalPages,
                    pageNo: states.page,
                    setPageNo: (data: number) => functions.setPageNo(data),
                    setSelectedValue: functions.setVisibleRows,
                    selectedValue: states.numOfRows,
                }}
            /> */}
            <CommonAgGrid
                rowHeight={40}
                rowData={states.rowData || []}
                columnDefs={(states.columnDefs as any) || []}
                gridHeight={states.deviceType === "Desktop" ? "90%" : "70%"}
                pagination={{
                    TotalPage: states.totalPages!,
                    pageNo: states.page,
                    setPageNo: (data: number) => functions.setPageNo(data),
                    setSelectedValue: functions.setVisibleRows,
                    selectedValue: states.numOfRows,
                }}
                loading={states.isSitesLoading}
            />
            <EditLocationDetails
                toggle={functions.toggle}
                ticket_id={states.editSiteData?.id}
                DealStates={states}
                isShown={states.isShown}
                location_data={states.editSiteData}
            />
        </>
    )
}

export default SitesTable
